import { Grid, Stack, Title } from '@mantine/core';

import { Forwarder } from '@e-origin/shared';

import { DatePickerInput, TextInput } from '@components';

interface ForwarderViewBusinessCardProps {
  forwarder: Forwarder;
}

export const ForwarderViewBusinessCard: React.FC<ForwarderViewBusinessCardProps> = ({ forwarder }) => {
  return (
    <Stack gap={40}>
      <Stack gap="sm">
        <Title order={4}>ID Card</Title>
        <Grid>
          <Grid.Col span={6}>
            <TextInput value={forwarder?.idCard.ownerName} label="Owner name" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <DatePickerInput label="Expiration Date" value={new Date(forwarder?.idCard.expirationDate || null)} disabled />
          </Grid.Col>
        </Grid>
      </Stack>

      <Stack gap="sm">
        <Title order={4}>Chinese business license</Title>
        <Grid>
          <Grid.Col span={6}>
            <TextInput value={forwarder?.businessLicense.nameEN} label="Company name EN" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <TextInput value={forwarder?.businessLicense.nameCN} label="Company name CN" disabled />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={6}>
            <TextInput value={forwarder?.idCard.ownerName} label="Owner name" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <TextInput value={forwarder?.businessLicense.registrationNumber} label="Registration number" disabled />
          </Grid.Col>
        </Grid>
      </Stack>

      <Stack gap="sm">
        <Title order={4}>EORI forwarder</Title>
        <Grid>
          <Grid.Col span={6}>
            <TextInput value={forwarder?.businessLicense.nameEN} label="Company name EN" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <TextInput value={forwarder?.eori.number} label="EORI number" disabled />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={3}>
            <TextInput value={forwarder?.eori.address.street} label="Street & number" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={forwarder?.eori.address.city} label="City" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={forwarder?.eori.address.zipCode} label="Zip code" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={forwarder?.eori.address.country} label="Country" disabled />
          </Grid.Col>
        </Grid>
      </Stack>

      <Stack gap="sm">
        <Title order={4}>VAT forwarder</Title>
        <Grid>
          <Grid.Col span={6}>
            <TextInput value={forwarder?.businessLicense.nameEN} label="Company name EN" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <TextInput value={forwarder?.vat.number} label="VAT forwarder" disabled />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={3}>
            <TextInput value={forwarder?.vat.address.street} label="Street & number" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={forwarder?.vat.address.city} label="City" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={forwarder?.vat.address.zipCode} label="Zip code" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={forwarder?.vat.address.country} label="Country" disabled />
          </Grid.Col>
        </Grid>
      </Stack>
    </Stack>
  );
};
